import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems = [] } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getTotalItems = () => {
    return cartItems.reduce((total, item) => total + (item.quantity || 0), 0);
  };
  const totalItems = getTotalItems();

  return (
    <header className="pg-header">
      <div className="promo-bar">
        <div className="container">
          Zero interest promo financing on purchases of $750 or more.{" "}
        </div>
      </div>

      <div className="header-main">
        <div className="container header-main__inner">
          <div className="header-main__center">
            <Link onClick={toTop} to="/" className="logo">
              Retteve
            </Link>
          </div>

          <div className="header-main__right">
            <Link
              onClick={toTop}
              to="/cartpage"
              className="icon-link cart-link"
            >
              <span className="icon">🛒</span>
              <span className="label">Cart</span>
              <span
                className="cart-count"
                aria-hidden={totalItems === 0 ? "true" : "false"}
              >
                {totalItems}
              </span>
            </Link>
          </div>
        </div>
      </div>

      <nav className="main-nav">
        <div className="container main-nav__inner">
          <Link onClick={toTop} to="/shop">
            Shop
          </Link>
          <Link onClick={toTop} to="/about">
            About Us
          </Link>
          <Link onClick={toTop} to="/contact">
            Contact Us
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
